<div class="modal-header">
    <h4 class="modal-title">{{ header }}</h4>
    <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title" (click)="modal.close()"></button>
</div>

<div class="modal-body">
    <div class="position-relative d-flex justify-content-center w-100 mb-3 mt-2">
        <ul class="nav nav-pills pill-switch nav-fill gap-2 small shadow rounded-5 ntkpi-card-tabs" id="pillNav2" role="tablist">
            <li class="nav-item" role="presentation" (click)="selectedTab.set(1)">
                <a class="nav-link active rounded-5" data-bs-toggle="tab" type="button" role="tab" aria-selected="true" href="#challenge">
                    {{ "ntkpi_card.challenge" | translate }}
                </a>
            </li>
            <li class="nav-item" role="presentation" (click)="selectedTab.set(2)">
                <a class="nav-link rounded-5" data-bs-toggle="tab" type="button" role="tab" aria-selected="false" href="#successStory">
                    {{ "ntkpi_card.success_story" | translate }}
                </a>
            </li>
        </ul>
    </div>

    @let periods = periodList();
    @if (periods.length > 0) {
        <div class="row d-flex justify-content-center align-items-center px-2">
            <div class="col-md-4 col-sm-6 col-xs-12">
                <adaa-form-dropdown
                    [clearable]="false"
                    [options]="periods"
                    [setDefaultValue]="periodId"
                    [isDisabled]="disableForm()"
                    (inputChanges)="updatePeriodId($event)"
                />
            </div>
        </div>
    }

    <div class="tab-content clearfix mt-2">
        @if (challengeAnalysisForm(); as challengeForm) {
            <form
                class="tab-pane fade bg-card shadow-md rounded p-2"
                id="challenge"
                [class.show]="selectedTab() === 1"
                [class.active]="selectedTab() === 1"
                [formGroup]="challengeForm"
            >
                <div class="row pb-2">
                    <div class="col-sm-6 col-xs-12">
                        <adaa-form-input
                            formControlName="analysis"
                            controlName="analysis"
                            [isTextArea]="true"
                            [label]="'ntkpi_card.challenge_analysis' | translate"
                            [required]="isRequired(validations.challengeAnalysis(), 'analysis')"
                            [invalid]="challengeForm.get('analysis')?.touched! && challengeForm.get('analysis')?.invalid!"
                            [adaaInputDisabled]="disableForm()"
                        />
                    </div>

                    <div class="col-sm-6 col-xs-12">
                        <adaa-form-input
                            formControlName="rootCause"
                            controlName="rootCause"
                            [isTextArea]="true"
                            [label]="'ntkpi_card.root_cause' | translate"
                            [required]="isRequired(validations.challengeAnalysis(), 'rootCause')"
                            [invalid]="challengeForm.get('rootCause')?.touched! && challengeForm.get('rootCause')?.invalid!"
                            [adaaInputDisabled]="disableForm()"
                        />
                    </div>
                </div>

                <div class="row pb-2">
                    <div class="col-sm-6 col-xs-12">
                        <adaa-form-input
                            formControlName="initialProposedTreatment"
                            controlName="initialProposedTreatment"
                            [isTextArea]="true"
                            [label]="'ntkpi_card.initial_proposed_assessment' | translate"
                            [required]="isRequired(validations.challengeAnalysis(), 'initialProposedTreatment')"
                            [invalid]="
                                challengeForm.get('initialProposedTreatment')?.touched! && challengeForm.get('initialProposedTreatment')?.invalid!
                            "
                            [adaaInputDisabled]="disableForm()"
                        />
                    </div>

                    <div class="col-sm-6 col-xs-12">
                        <adaa-form-input
                            formControlName="pmoRequirement"
                            controlName="pmoRequirement"
                            [isTextArea]="true"
                            [label]="'ntkpi_card.pmo_requirement' | translate"
                            [required]="isRequired(validations.challengeAnalysis(), 'pmoRequirement')"
                            [invalid]="challengeForm.get('pmoRequirement')?.touched! && challengeForm.get('pmoRequirement')?.invalid!"
                            [adaaInputDisabled]="disableForm()"
                        />
                    </div>
                </div>

                <div class="row pb-2">
                    <div class="col-12">
                        <adaa-form-dropdown
                            formControlName="assessment"
                            controlName="assessment"
                            [clearable]="true"
                            [options]="challengeAssessments()"
                            [label]="'ntkpi_card.challenge_assessment' | translate"
                            [required]="isRequired(validations.challengeAnalysis(), 'assessment')"
                            [invalid]="challengeForm.get('assessment')?.touched! && challengeForm.get('assessment')?.invalid!"
                            [adaaInputDisabled]="disableForm()"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <adaa-form-input-file
                            dropFileZoneMessage="ntkpi_card.supporting_evidence"
                            [onDeleteRemoveFile]="false"
                            [allowedFileSize]="26214400"
                            [allowedFiles]="allowedFiles"
                            [file]="evidenceFileChallenge"
                            [isDisabled]="disableForm()"
                            (inputChanges)="evidenceFileChallengeChanged($event)"
                        />
                    </div>
                </div>
            </form>
        }
        @if (successStoryForm(); as successForm) {
            <form
                class="tab-pane fade bg-card shadow-md rounded p-2"
                id="successStory"
                [class.show]="selectedTab() === 2"
                [class.active]="selectedTab() === 2"
                [formGroup]="successForm"
            >
                <div class="row pb-2">
                    <div class="col-sm-6 col-xs-12">
                        <adaa-form-input
                            formControlName="achievementTitle"
                            controlName="achievementTitle"
                            [label]="'ntkpi_card.achievement_title' | translate"
                            [required]="isRequired(validations.successStory(), 'achievementTitle')"
                            [invalid]="successForm.get('achievementTitle')?.touched! && successForm.get('achievementTitle')?.invalid!"
                            [adaaInputDisabled]="disableForm()"
                        />
                    </div>

                    <div class="col-sm-6 col-xs-12">
                        <adaa-form-dropdown
                            formControlName="leadershipLevel"
                            controlName="leadershipLevel"
                            [clearable]="true"
                            [options]="leadershipLevels()"
                            [label]="'ntkpi_card.leadership_level' | translate"
                            [required]="isRequired(validations.successStory(), 'leadershipLevel')"
                            [invalid]="successForm.get('leadershipLevel')?.touched! && successForm.get('leadershipLevel')?.invalid!"
                            [adaaInputDisabled]="disableForm()"
                        />
                    </div>
                </div>

                <div class="row pb-2">
                    <div class="col-sm-6 col-xs-12">
                        <adaa-form-input
                            formControlName="achievementDsc"
                            controlName="achievementDsc"
                            [isTextArea]="true"
                            [label]="'ntkpi_card.description' | translate"
                            [required]="isRequired(validations.successStory(), 'achievementDsc')"
                            [invalid]="successForm.get('achievementDsc')?.touched! && successForm.get('achievementDsc')?.invalid!"
                            [adaaInputDisabled]="disableForm()"
                        />
                    </div>

                    <div class="col-sm-6 col-xs-12">
                        <adaa-form-input
                            formControlName="impactAchievementTarget"
                            controlName="impactAchievementTarget"
                            [isTextArea]="true"
                            [label]="'ntkpi_card.achievement_target' | translate"
                            [required]="isRequired(validations.successStory(), 'impactAchievementTarget')"
                            [invalid]="successForm.get('impactAchievementTarget')?.touched! && successForm.get('impactAchievementTarget')?.invalid!"
                            [adaaInputDisabled]="disableForm()"
                        />
                    </div>
                </div>

                <div class="row pb-2">
                    <div class="col-sm-6 col-xs-12">
                        <adaa-form-input
                            formControlName="impactAchievementSociety"
                            controlName="impactAchievementSociety"
                            [isTextArea]="true"
                            [label]="'ntkpi_card.achievement_society' | translate"
                            [required]="isRequired(validations.successStory(), 'impactAchievementSociety')"
                            [invalid]="successForm.get('impactAchievementSociety')?.touched! && successForm.get('impactAchievementSociety')?.invalid!"
                            [adaaInputDisabled]="disableForm()"
                        />
                    </div>

                    <div class="col-sm-6 col-xs-12">
                        <adaa-form-input
                            formControlName="beneficiaries"
                            controlName="beneficiaries"
                            [isTextArea]="true"
                            [label]="'ntkpi_card.beneficiaries' | translate"
                            [required]="isRequired(validations.successStory(), 'beneficiaries')"
                            [invalid]="successForm.get('beneficiaries')?.touched! && successForm.get('beneficiaries')?.invalid!"
                            [adaaInputDisabled]="disableForm()"
                        />
                    </div>
                </div>

                <div class="row pb-2">
                    <div class="col-sm-6 col-xs-12">
                        <adaa-form-input-date
                            formControlName="projectLaunchDate"
                            controlName="projectLaunchDate"
                            [label]="'ntkpi_card.launch_date' | translate"
                            [required]="isRequired(validations.successStory(), 'projectLaunchDate')"
                            [invalid]="successForm.get('projectLaunchDate')?.touched! && successForm.get('projectLaunchDate')?.invalid!"
                            [adaaInputDisabled]="disableForm()"
                        />
                    </div>

                    <div class="col-sm-6 col-xs-12">
                        <adaa-form-dropdown
                            formControlName="projectContinuity"
                            controlName="projectContinuity"
                            [clearable]="true"
                            [options]="continuityOptions()"
                            [label]="'ntkpi_card.continuity_project' | translate"
                            [required]="isRequired(validations.successStory(), 'projectContinuity')"
                            [invalid]="successForm.get('projectContinuity')?.touched! && successForm.get('projectContinuity')?.invalid!"
                            [adaaInputDisabled]="disableForm()"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <adaa-form-input-file
                            dropFileZoneMessage="ntkpi_card.supporting_evidence"
                            [onDeleteRemoveFile]="false"
                            [allowedFileSize]="26214400"
                            [allowedFiles]="allowedFiles"
                            [file]="evidenceFileSuccessStory"
                            [isDisabled]="disableForm()"
                            (inputChanges)="evidenceFileSuccessStoryChanged($event)"
                        />
                    </div>
                </div>
            </form>
        }
    </div>
    <div class="modal-footer d-flex justify-content-center">
        <button type="button" class="btn btn-secondary" (click)="modal.close()">{{ "common.form.button.close" | translate }}</button>

        @if (!disableForm()) {
            <button type="button" class="btn btn-primary" (click)="selectedTab() === 1 ? saveChallenge() : saveSuccessStory()">
                {{ submitButtonContent() }}
            </button>
        }
    </div>
</div>
